export type ToastType = "success" | "error" | "warn" | "info" | "default";

interface ToastProps {
  message: string;
  type: ToastType;
  visible: boolean;
}

export default function Toast({ message, type, visible }: ToastProps) {
  return (
    <div className={`appToast appToast--${type}${visible ? " appToast--visible" : ""}`}>
      {message}
    </div>
  );
}
